// Escolhe a área de detalhe da tela de Desembolso: a EAP do empreendimento ou o
// catálogo de insumos. Vivia dentro de `DisbursementList`, que saiu da tela — o
// seletor é da PÁGINA, não da lista.
//
// São abas (padrão WAI-ARIA, ativação automática): as duas visões ficam à vista com o
// rótulo e a pergunta que cada uma responde, em vez de escondidas num `<select>` pequeno
// no canto do bloco. Setas esquerda/direita, Home e End trocam de aba pelo teclado.
import { useRef } from "react";

export const DETAIL_PANEL_ID = "ampli-disbursement-detail-panel";

const VIEWS = [
  { value: "node", label: "EAP", hint: "Forma de pagar por nível da obra" },
  {
    value: "resource",
    label: "Insumos",
    hint: "Forma de pagar por insumo ou família",
  },
];

const tabId = (value) => `ampli-disbursement-view-${value}`;

const DisbursementViewSwitch = ({ value, onChange }) => {
  const tabs = useRef({});

  const select = (next) => {
    if (next !== value) onChange?.(next);
    tabs.current[next]?.focus();
  };

  const onKeyDown = (event) => {
    const index = VIEWS.findIndex((view) => view.value === value);
    const last = VIEWS.length - 1;
    const target = {
      ArrowRight: index === last ? 0 : index + 1,
      ArrowLeft: index === 0 ? last : index - 1,
      Home: 0,
      End: last,
    }[event.key];
    if (target === undefined) return;
    event.preventDefault();
    select(VIEWS[target].value);
  };

  return (
    <div className="ampli-view-switch">
      <div className="ampli-view-switch__heading">
        <h3>Detalhamento do desembolso</h3>
        <p>Escolha por onde definir a forma de pagar.</p>
      </div>
      <div
        className="ampli-view-switch__tabs"
        role="tablist"
        aria-label="Filtrar por tipo de alvo"
        onKeyDown={onKeyDown}
      >
        {VIEWS.map((view) => {
          const active = view.value === value;
          return (
            <button
              key={view.value}
              ref={(node) => {
                tabs.current[view.value] = node;
              }}
              id={tabId(view.value)}
              type="button"
              role="tab"
              aria-selected={active}
              aria-controls={DETAIL_PANEL_ID}
              tabIndex={active ? 0 : -1}
              className={`ampli-view-switch__tab${active ? " is-active" : ""}`}
              onClick={() => select(view.value)}
            >
              <span className="ampli-view-switch__label">{view.label}</span>
              <span className="ampli-view-switch__hint">{view.hint}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export { tabId as viewTabId };
export default DisbursementViewSwitch;
